module.exports = __webpack_public_path__ + "static/media/banner.e9ec8eaa.png";